import * as React from 'react';
import { ActivitySchedule, ActivityDefinition } from '../../../model/activities';
import { CalendarEvent, emptyEvent } from '../BigCalendar';
import { CalendarDetail } from './CalendarDetail';
import { Grid, Switch, FormControlLabel } from '@material-ui/core';
import { SearchBoxApi } from '../../SearchBoxApi/SearchBoxApi';
import { tag } from '../../../model/tag';
import { trainer } from '../../../model/trainer';

interface IProps {
    onCreate: (a: ActivitySchedule) => any;
    classes: any, onUndo: () => any;
    allActivities: ActivityDefinition[];
    allTags: tag[];
    trainers: trainer[];
}
export const NewEventComponentNoActivity = (props: IProps) => {
    /*    event: CalendarEvent;
    classes: any;
    onSave: (a: ActivitySchedule) => any;
    onDelete?: (id: string) => any;
    loading: boolean; */
    const [sourceActivity, setSourceActivity] = React.useState<ActivityDefinition>();
    const [event, setEvent] = React.useState<CalendarEvent>(emptyEvent);
    const [spotEvent, setSpotEvent] = React.useState(false);
    const onActivityDefinitionSelected = (a: ActivityDefinition) => {
        setSourceActivity(a);
        if (a) {
            setSpotEvent(false);
            const now = new Date();
            now.setMinutes(0);
            now.setSeconds(0);
            const start = now;
            const end = new Date(now.setMinutes(60));
            const s: ActivitySchedule = {
                isReservable: a.isReservable,
                activityDefinitionId: a._id,
                date: start,
                displayName: a.displayName,
                description: a.description,
                duration: 60,
                capacity: 10,
                trainerIds: a.trainerIds,
                tag: a.tag,
                state: a.state
            }
            const e: CalendarEvent = {
                title: s.displayName,
                start: start,
                end: end,
                resource: s
            }
            setEvent(e)
        }
        else setEvent(emptyEvent);
    }
    const templateSearchBoxActivityDefinition = (act?: ActivityDefinition) => {
        return act ? {
            label: `${act.displayName} - ${act.description}`,
            value: act
        } : undefined;
    }
    const searchActivityDefinition = (text: string, take?: number) => {
        const t = text.toLowerCase();
        if (props.allActivities)
            return Promise.resolve(props.allActivities.filter(a => a.description.toLowerCase().indexOf(t) > -1 || a.displayName.toLowerCase().indexOf(t) > -1));
        return Promise.reject();
    }
    const toggleSpotEvent = (val: boolean) => {
        setSpotEvent(val);
        if (val) {
            setSourceActivity(undefined);
            setEvent(emptyEvent);
        }
    }
    return <Grid container sm={12}>
        <Grid container style={{ alignItems: 'center' }} sm={12}>
            <Grid item sm={8}>
                <SearchBoxApi<ActivityDefinition>
                    selectedItem={sourceActivity}
                    openOnFocus
                    doFilter
                    listSize={10}
                    getItems={searchActivityDefinition}
                    label={"Attività"}
                    placeholder={"Cerca per descrizione o nome"}
                    templateItem={templateSearchBoxActivityDefinition}
                    onSelectedChange={onActivityDefinitionSelected} />
            </Grid>
            <Grid item sm={4}>
                <FormControlLabel style={{ marginLeft: 0, marginRight: 0, paddingLeft: 5 }}
                    control={
                        <Switch onChange={(e, val) => toggleSpotEvent(val)} value={spotEvent} />
                    }
                    labelPlacement='start'
                    label="Evento occasionale"
                />
            </Grid>
        </Grid>
        <Grid item sm={12}>
            <CalendarDetail fullEdit={spotEvent}
                trainers={props.trainers}
                allTags={props.allTags}
                disabled={!sourceActivity}
                classes={props.classes}
                onSave={props.onCreate}
                loading={false}
                event={event}
                onUndo={props.onUndo}
                minDate={sourceActivity?.validFrom}
                maxDate={sourceActivity?.expiresOn} />
        </Grid>
    </Grid>
}